import {
  Alert,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

const PrepareBatchPanel = ({ campaign, onPrepare, preparing, lastResult }) => {
  const [batchSize, setBatchSize] = useState("200");
  const [excludeAlreadyContactedInGroup, setExcludeAlreadyContactedInGroup] = useState(true);
  const [excludeAlreadyRegistered, setExcludeAlreadyRegistered] = useState(false);
  const [excludeAlreadyRequested, setExcludeAlreadyRequested] = useState(false);
  const [minDaysSinceLastSms, setMinDaysSinceLastSms] = useState("");
  const [onlyValidMobiles, setOnlyValidMobiles] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!campaign) return;
    setBatchSize(String(campaign.batchSize || 200));
  }, [campaign]);

  const canPrepare =
    campaign &&
    [1, 2].includes(Number(campaign.status)) &&
    Number(campaign.channel) === 1 &&
    Number(campaign.sendMode) !== 2; // Hide for automatic mode (2)

  const handlePrepare = async () => {
    setError("");
    const size = Number(batchSize);
    if (!size || size <= 0) {
      setError("اندازه دسته باید بزرگ‌تر از صفر باشد.");
      return;
    }
    const payload = {
      batchSize: size,
      excludeAlreadyContactedInGroup,
      excludeAlreadyRegistered,
      excludeAlreadyRequested,
      onlyValidMobiles,
      minDaysSinceLastSms: minDaysSinceLastSms ? Number(minDaysSinceLastSms) : null,
    };
    const result = await onPrepare(payload);
    if (result?.error) setError(result.error);
  };

  if (!canPrepare) return null;

  return (
    <Box sx={{ mb: 3, p: 2, border: "1px solid", borderColor: "divider", borderRadius: 1 }}>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        آماده‌سازی دسته مخاطبین
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        مخاطبین واجد شرایط انتخاب و در صف ارسال ثبت می‌شوند. پیامکی در این مرحله ارسال نمی‌شود.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <TextField
            label="اندازه دسته"
            type="number"
            fullWidth
            size="small"
            value={batchSize}
            onChange={(e) => setBatchSize(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="حداقل فاصله از آخرین پیامک (روز)"
            type="number"
            fullWidth
            size="small"
            value={minDaysSinceLastSms}
            onChange={(e) => setMinDaysSinceLastSms(e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={excludeAlreadyContactedInGroup}
                onChange={(e) => setExcludeAlreadyContactedInGroup(e.target.checked)}
              />
            }
            label="حذف مخاطبین قبلاً پیامک‌گرفته در گروه"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={excludeAlreadyRegistered}
                onChange={(e) => setExcludeAlreadyRegistered(e.target.checked)}
              />
            }
            label="حذف ثبت‌نام‌شده‌ها"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={excludeAlreadyRequested}
                onChange={(e) => setExcludeAlreadyRequested(e.target.checked)}
              />
            }
            label="حذف دارای درخواست پروژه"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={onlyValidMobiles}
                onChange={(e) => setOnlyValidMobiles(e.target.checked)}
              />
            }
            label="فقط شماره‌های معتبر"
          />
        </Grid>
      </Grid>
      {error ? (
        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
          {error}
        </Typography>
      ) : null}
      {lastResult ? (
        <Alert severity="info" sx={{ mt: 2 }}>
          {lastResult.selected} مخاطب انتخاب شد از {lastResult.totalEligible} واجد شرایط
          {lastResult.skippedAlreadyRecipient
            ? ` | ${lastResult.skippedAlreadyRecipient} قبلاً در کمپین`
            : ""}
        </Alert>
      ) : null}
      <Button
        variant="outlined"
        sx={{ mt: 2 }}
        onClick={handlePrepare}
        disabled={preparing}
      >
        {preparing ? "در حال آماده‌سازی..." : "آماده‌سازی دسته"}
      </Button>
    </Box>
  );
};

export default PrepareBatchPanel;
